module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAMCAYAAAC9QufkAAAAy0lEQVQokZXQsUrCURgF8J8i4tCQ7yAR+AIhBC4tLilUW1NPED5Bi5MPIQnOPoC1Ro8QivN/EGmpocWG//cHFcPbgQPn3vMdvnNvqTkbTHHtb0zRO2RUjgShi3roH3wVRvlIsMA6+Im7/4ZfcYURJrglr52CDDO8yGtPsEkNF9jgEScYp9auyj+tjlO8o5a6+Sa4g9TNB1HGW+ghOqEzLLeYxX0n5mBZQQsfOMd3GJdYbC1pYI6LmJvjrHjzA57RRn8vKM59PGGFe/gFDD4nzVufcqEAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/alarm/distance-time-icon.png
// module id = VlI7
// module chunks = 1